import React from "react";
import { useTranslation } from "react-i18next";
import { FaAward, FaUsers } from "react-icons/fa";
import { MdAddBusiness } from "react-icons/md";
import { VscFolderLibrary } from "react-icons/vsc";
// import ME from "../../assets/avatars/me-about.jpg";
import "./about.css";

const About = () => {
  const { t } = useTranslation();

  return (
    <section id="about">
      <h4>{t("about.subtitle")}</h4>
      <h2>{t("about.title")}</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            {/* <img src={ME} alt="About me" /> */}
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <h5>{t("about.cards.title.experience")}</h5>
              <small>{t("about.cards.subtitle.years")}</small>
            </article>
            <article className="about__card">
              <h5>{t("about.cards.title.projects")}</h5>
              <small>{t("about.cards.subtitle.completed")}</small>
            </article>
            <article className="about__card">
              <h5>{t("about.cards.title.clients")}</h5>
              <small>{t("about.cards.subtitle.satisfaction")}</small>
            </article>
            <article className="about__card">
              <h5>{t("about.cards.title.companies")}</h5>
              <small>{t("about.cards.subtitle.billing")}</small>
            </article>
          </div>

          <p>{t("about.description")}</p>

          <a href="#contact" className="about__button">
            {t("about.button")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
